import { render, staticRenderFns } from "./LocalStorage.vue?vue&type=template&id=465eb967&scoped=true"
import script from "./LocalStorage.vue?vue&type=script&lang=js"
export * from "./LocalStorage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465eb967",
  null
  
)

export default component.exports